import { colorOptions } from "src/shared/modules/profile/theme/themeConstants";
import api from "../../../../../features/auth/axiosConfig";

export interface Theme {
  backgroundColor: string;
  fontColor: string;
  fontFamily: string;
  businessName?: string;
}

export const useThemeSetup = (organization_name: string = "default") => {
  const setupTheme = async (organization_name: string) => {
    try {
      const res = await api.get(`/pos/v2/theme`);
      const themes: Theme[] = res.data.result;

      if (themes.length > 0) {
        const apiTheme = themes[0];
        const bg = String(apiTheme.backgroundColor);

        // ✅ Find matching key in colorOptions (like "DodgerBlue" for "#1E90FF")
        const matchedEntry = Object.entries(colorOptions).find(([key, value]) => value.includes(bg));
        const matchedColorKey = matchedEntry ? matchedEntry[0] : "DodgerBlue";

        // ✅ If old theme (like "#6495ED" + "Franklin Gothic Medium"), reset to new default
        let finalTheme: Theme;

        if (apiTheme.backgroundColor === "#6495ED" && apiTheme.fontColor === "white" && apiTheme.fontFamily === "Franklin Gothic Medium") {
          // Old default detected → migrate to new default
          finalTheme = {
            backgroundColor: "DodgerBlue",
            fontColor: "white",
            fontFamily: "Sans-serif",
          };
          await api.put(`/pos/v2/theme`, finalTheme); // only update if old default
          window.location.reload();
        } else {
          finalTheme = {
            backgroundColor: matchedColorKey || apiTheme.backgroundColor,
            fontColor: apiTheme.fontColor,
            fontFamily: apiTheme.fontFamily,
          };
        }

        // ✅ Save in sessionStorage
        Object.entries(finalTheme).forEach(([key, value]) => sessionStorage.setItem(`${key}${organization_name}`, value));

        return finalTheme;
      }
    } catch (error) {
      console.error("Theme setup error:", error);
      const fallbackTheme: Theme = {
        backgroundColor: "DodgerBlue",
        fontColor: "white",
        fontFamily: "Sans-serif",
      };
      Object.entries(fallbackTheme).forEach(([key, value]) => sessionStorage.setItem(`${key}${organization_name}`, value));
      return fallbackTheme;
    }
  };

  return { setupTheme };
};
